import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import FloatingAdd from "./FloatingAdd";
import ExpenseForm from "./ExpenseForm";
import HomeExpenseForm from "../../home/form/HomeExpenseForm";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '96vw',
  maxWidth:'380px',
  maxHeight: '90vh',
  overflowY: 'auto',
  m:'1',
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 2,
  py: 4,
};

export default function ModalForm() {
  const [open, setOpen] = React.useState(false);
  const [formType, setFormType] = React.useState("shared_expense");
  const navigate=useNavigate();
  const handleOpen = (type) => {
    setFormType(type);
    if(type==='home_expense')
      navigate(`../home`)
    // Note: we intentionally do NOT navigate to /panel for shared_expense
    // to avoid re-triggering the friends-check redirect in SideBar.
    // Solo shared expenses (no friends) are fully supported.
    setOpen(true);
  }
  const handleClose = () => setOpen(false);

  // React.useEffect(() => {
  //   setTimeout(() => {
  //     handleOpen();
  //   }, 200);
  // }, []);
  return (
    <div style={{position:"relative"}}>
      <FloatingAdd onclick={handleOpen} />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography variant="h5" gutterBottom>
            Add {
              formType === "shared_expense" ? "Shared Expense" : "Home Expense"
            }
            </Typography>
            <br></br>
            {
              formType === "shared_expense" ? <ExpenseForm handleClose={handleClose} /> : <HomeExpenseForm handleClose={handleClose} />
            }
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
